var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"checkmark-toggle",class:{ 'checkmark-toggle-checked': _vm.isChecked },style:({ height: _vm.pixelSize, width: _vm.pixelSize })},[_c('check-svg',{directives:[{name:"visible",rawName:"v-visible",value:(_vm.isChecked),expression:"isChecked"}],attrs:{"pixelSize":_vm.svgPixelSize}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }